import { ProjectInfo } from 'library/ts/ProjectInfo';
import { Capabilities } from 'library/ts/utilities/Capabilities';
import { declareNamespace } from 'library/ts/utilities/modules/DOM';
import { Utilities } from 'library/ts/utilities/Utilities';
window.PlayerServicesProjectInfo = ProjectInfo;
export const setupPlayerServicesNamespace = () => {
    return new Promise((resolve, reject) => {
        const rootNamespace = 'PARA.PlayerServices';
        const utils = Utilities.getInstance();
        const initializeCapabilities = () => {
            if (utils.Type.isEmpty((window?.PARA?.PlayerServices?.Capabilities))) {
                new Capabilities(utils).detect().then((data) => {
                    onCapabilitiesReady(data.result);
                });
            }
            else {
                onCapabilitiesReady(window?.PARA?.PlayerServices?.Capabilities);
            }
        };
        const onCapabilitiesReady = (capabilities) => {
            window.PARA.PlayerServices.Capabilities = capabilities;
            resolve(window.PARA);
        };
        if (utils.Type.isEmpty(utils.DOM.getDeepVal(window, rootNamespace))) {
            declareNamespace(rootNamespace);
        }
        if (!utils.Type.isNumber((window?.PARA?.PlayerServices?.StartTime))) {
            window.PARA.PlayerServices.StartTime = new Date().getTime();
        }
        if (utils.Type.isEmpty((window?.PARA?.PlayerServices?.Utilities))) {
            window.PARA.PlayerServices.Utilities = utils;
        }
        initializeCapabilities();
    });
};
